/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/nsmp/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* loadNsmpArquivos(nsmpData) {
  let fotos = [];

  if (nsmpData && nsmpData.arquivos && nsmpData.arquivos.length > 0) {
    fotos = yield FileService.downloadArquivos(nsmpData.arquivos, false);
  }

  if (nsmpData && nsmpData.fotos && nsmpData.fotos.length > 0) {
    for (let foto of nsmpData.fotos) {
      let nameSplit = foto.nome.split('.');
      let src = foto.image && (foto.image.includes('data:image') || foto.image.includes('data:application')) ? foto.image : `data:image/png;base64,${foto.image}`;

      fotos.push({
        id: foto.id,
        nome: nameSplit[0],
        extensao: nameSplit.length > 1 ? nameSplit[1] : 'png',
        src: src,
        alt: foto.nome,
        file: yield FileService.base64ToFile(foto.image, foto.nome),
        image: src,
        description: foto.description,
        additions: foto.additions,
        origem: foto.origem,
      });
    }
  }
      
  return fotos;
}

function* loadSubNsmpArquivos(nsmpData) {
  let subNsmps = [];
  if (nsmpData && nsmpData.subNsmps && nsmpData.subNsmps.length > 0) {
    for (let subNsmpData of nsmpData.subNsmps) {
      let subNsmpArquivos = [];
      if (subNsmpData && subNsmpData.arquivos && subNsmpData.arquivos.length > 0) {
        subNsmpArquivos = yield FileService.downloadArquivos(subNsmpData.arquivos, false);
      }

      subNsmps.push({ ...subNsmpData, arquivos: subNsmpArquivos });
    }
  }
      
  return subNsmps;
}

function* loadNsmpById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    
    const response = yield BaseService.get({ url: `nsmps/${id}` });
    response.data.fotos = yield loadNsmpArquivos(response.data);
    response.data.subNsmps = yield loadSubNsmpArquivos(response.data);

    yield put({
      type: TypeActions.NSMPS_FIND_BY_ID_SUCCESS,
      data: response.data
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao carregar as informações!'
    });
  }
}

function* save({ data, callback }) {
  try {
    const fotos = data.fotos;
    delete data.fotos;
    const arquivos = [];
    for(let foto of fotos) {
      arquivos.push({ 
        externalId: foto.externalId,
        nome: foto.nome,
        extensao: foto.extensao,
        file: foto.file
      });
    }

    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    let uploadArquivosValid = true;
    const response = yield BaseService.post({ url: 'nsmps', data: { ...data, arquivos: FileService.getArquivosToUpload(arquivos, true) } });
    if (response.data && response.data.arquivos) {
      uploadArquivosValid = yield FileService.uploadArquivos(arquivos, response.data.arquivos, "externalId");
    }

    if (uploadArquivosValid) {
      const merged = {
        ...response.data,
        fotos: fotos
      };
      yield put({
        type: TypeActions.NSMPS_SAVE_SUCCESS,
        data: merged
      });
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
        message: 'Informações salvas com sucesso!'
      });
      if (typeof callback === 'function') {
        callback(true, merged);
      }
    } else {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message: 'Erro ao realizar o upload dos arquivos. Por favor, tente novamente!'
      });
      if (typeof callback === 'function') {
        callback(false);
      }
    }

    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
    if (typeof callback === 'function') {
      callback(false);
    }
  }
}

function* patchNsmpAuditoria({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const body = { auditoria: data.auditoria };
    if (data.auditoriaDescription !== undefined && data.auditoriaDescription !== null) {
      body.auditoriaDescription = data.auditoriaDescription;
    }
    const response = yield BaseService.patch({
      url: `nsmps/${data.nsmpId}/auditoria`,
      data: body
    });
    yield put({
      type: TypeActions.NSMPS_PATCH_AUDITORIA_SUCCESS,
      data: response.data
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Auditoria atualizada com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    if (typeof callback === 'function') {
      callback();
    }
  } catch (error) {
    let message = 'Erro ao atualizar auditoria!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para alterar auditoria.';
    } else if (error.response && error.response.status === 400 && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  }
}

function* update({ data, callback }) {
  try {
    const isNotClone = !data.idNsmpReference;
    const arquivos = [];
    const fotos = data.fotos;
    delete data.fotos;

    for (let foto of fotos) {
      arquivos.push({ 
        externalId: foto.externalId ? foto.externalId : foto.id,
        nome: foto.nome,
        extensao: foto.extensao ? foto.nome.split('.').pop() : 'jpeg',
        file: foto.file ? foto.file : FileService.base64ToFile(foto.image, foto.nome)
      });
    }

    yield put({ type: LoaderTypeActions.LOADER_SHOW });

    let uploadArquivosValid = true;
    const response = yield BaseService.put({ url: `nsmps/${data.id}`, data: { ...data, arquivos: FileService.getArquivosToUpload(arquivos, true) } });
    if (data.updateFiles && response.data && response.data.arquivos && isNotClone) {
      uploadArquivosValid = yield FileService.uploadArquivos(arquivos, response.data.arquivos, "externalId");
    }

    if (uploadArquivosValid) {
      const merged = {
        ...response.data,
        fotos: fotos
      };
      yield put({
        type: TypeActions.NSMPS_UPDATE_SUCCESS,
        data: merged
      });
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
        message: 'Informações salvas com sucesso!'
      });
      if (typeof callback === 'function') {
        callback(true, merged);
      }
    } else {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message: 'Erro ao realizar o upload dos arquivos. Por favor, tente novamente!'
      });
      if (typeof callback === 'function') {
        callback(false);
      }
    }
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!'
    });
    if (typeof callback === 'function') {
      callback(false);
    }
  }
}

function* deleteById({ id }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.delete({ url: `nsmps/${id}`});
    yield put({
      type: TypeActions.NSMPS_DELETE_SUCCESS,
      data: response.data
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao remover as informações!'
    });
  }
}

function* deleteCloneById({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.delete({ url: `nsmps/clone/${id}`});
    yield put({ type: TypeActions.NSMPS_DELETE_CLONE_SUCCESS, data: response.data, id });
    yield callback();
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações removidas com sucesso!'
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao remover as informações!'
    });
  }
}


function* clone({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: `nsmps/${id}/clone` });
    yield put({ type: TypeActions.NSMPS_CLONE_SUCCESS, data: response.data });
    yield callback();
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Nsmp clonada com sucesso!'
    })
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao clonar a nsmp!'
    });
  }
}

function* importUsoMutuo({ nsirId, data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: `nsmps/import/uso-mutuo/${nsirId}`, data });
    yield put({ type: TypeActions.NSMPS_IMPORT_USO_MUTUO_SUCCESS });
    const corpo = (response && response.data) || {};
    const total = corpo.totalPostes != null ? corpo.totalPostes : 0;
    const atualizados = Number(corpo.postesAtualizados) || 0;
    let message = `Postes importados com sucesso. Total: ${total}.`;
    if (atualizados > 0) {
      const rotulo = atualizados === 1
        ? 'poste já existente foi sobrescrito'
        : 'postes já existentes foram sobrescritos';
      message += ` ${atualizados} ${rotulo}.`;
    }
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message
    })
    if (typeof callback === 'function') yield callback(corpo);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    yield console.log(error);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao importar os postes!'
    });
  }
}

function* patchNsmpDigitacao({ data, pathSuffix }) {
  const { callback, nsirId, id, ...body } = data;
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.patch({
      url: `nsmps/${id}/${pathSuffix}`,
      data: body,
    });
    const merged = {
      ...response.data,
      nsirId,
    };
    yield put({
      type: TypeActions.NSMPS_DIGITAR_SUCCESS,
      data: merged,
    });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Informações salvas com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    if (typeof callback === 'function') {
      callback(true, merged);
    }
  } catch (error) {
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    if (error.response && error.response.status === 409) {
      const mensagem =
        error.response.data?.mensagem
        || 'Esta NSIR foi reatribuída. Suas alterações não foram salvas.';
      if (typeof callback === 'function') {
        callback(false, mensagem, 409);
      } else {
        yield put({
          type: ToastTypeActions.TOAST_MESSAGE_ERROR,
          message: mensagem,
        });
      }
      return;
    }
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao salvar as informações!',
    });
    if (typeof callback === 'function') {
      callback(false, null);
    }
  }
}

function* digitarNsmp({ data }) {
  yield patchNsmpDigitacao({ data, pathSuffix: 'digitacao' });
}

function* digitarNsmpUsoMutuo({ data }) {
  yield patchNsmpDigitacao({ data, pathSuffix: 'digitacao-uso-mutuo' });
}

export default function* watchAuth() {
  yield takeLatest(TypeActions.NSMPS_FIND_BY_ID, loadNsmpById);
  yield takeLatest(TypeActions.NSMPS_SAVE, save);
  yield takeLatest(TypeActions.NSMPS_UPDATE, update);
  yield takeLatest(TypeActions.NSMPS_PATCH_AUDITORIA, patchNsmpAuditoria);
  yield takeLatest(TypeActions.NSMPS_DIGITAR, digitarNsmp);
  yield takeLatest(TypeActions.NSMPS_DIGITAR_USO_MUTUO, digitarNsmpUsoMutuo);
  yield takeLatest(TypeActions.NSMPS_DELETE, deleteById);
  yield takeLatest(TypeActions.NSMPS_DELETE_CLONE, deleteCloneById);
  yield takeLatest(TypeActions.NSMPS_CLONE, clone);
  yield takeLatest(TypeActions.NSMPS_IMPORT_USO_MUTUO, importUsoMutuo);
}